import { Component, OnInit } from '@angular/core';
import { StudentAccount } from '@app/definitions/interfaces';
import { AccountService } from '@app/teacher/services/account.service';
import { AccountService as UserService } from '@app/core/services';
import { declensionOfNumerals } from '@app/_utils/helpers';
import { HandlerService } from '@app/_services/handler.service';

@Component({
    selector: 'app-profile-bank',
    templateUrl: './profile-bank.component.html',
    styleUrls: ['./profile-bank.component.scss']
})
export class ProfileBankComponent implements OnInit {
    studentAccount: StudentAccount;
    student_amount: number = 0;
    currencyStr = '';

    constructor(
        private accountService: AccountService,
        private userService: UserService,
        private handlerService: HandlerService
    ) {}

    ngOnInit() {
        this.getBankData();
    }

    private getBankData(): void {
        setTimeout(() => {
            const groupInstance = this.accountService.currentGroupInstance;
            this.accountService.getStudentAccount(groupInstance).subscribe(resp => {
                this.studentAccount = resp;
                this.student_amount = Math.round(resp.amount);
                this.setCurrency();
            });
        }, 1500);
    }

    private setCurrency(): void {
        this.userService.getCurrentCurrency().subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (!resp.errors.length) {
                this.currencyStr = declensionOfNumerals(this.student_amount, resp.data);
            }
        });
    }
}
